import { createContext, useContext, useEffect, useState } from "react";
import { useARC } from "providers/ARC/ARCProvider";

export const LandmarksContext = createContext();
LandmarksContext.displayName = "Landmarks";
export const useLandmarks = () => useContext(LandmarksContext);

const LandmarksProvider = ({ children }) => {
    const { selectedARC } = useARC();
    const [landmarks, setLandmarks] = useState([]);

    // Load landmarks from localStorage on mount or when ARC changes
    useEffect(() => {
        if (!selectedARC?.serialNumber) {
            setLandmarks([]);
            return;
        }

        const storageKey = `arc_landmarks_${selectedARC.serialNumber}`;
        const stored = localStorage.getItem(storageKey);
        if (stored) {
            try {
                setLandmarks(JSON.parse(stored));
            } catch (error) {
                console.error("Error loading landmarks from localStorage:", error);
                setLandmarks([]);
            }
        } else {
            setLandmarks([]);
        }
    }, [selectedARC?.serialNumber]);

    // Save landmarks to localStorage whenever they change
    useEffect(() => {
        if (!selectedARC?.serialNumber) return;

        const storageKey = `arc_landmarks_${selectedARC.serialNumber}`;
        localStorage.setItem(storageKey, JSON.stringify(landmarks));
    }, [landmarks, selectedARC?.serialNumber]);

    // Add a new landmark
    const addLandmark = (landmark) => {
        const newLandmark = {
            ...landmark,
            id: Date.now()
        };
        setLandmarks(prev => [...prev, newLandmark]);
    };

    // Update existing landmark
    const updateLandmark = (id, updates) => {
        setLandmarks(prev =>
            prev.map(l => l.id === id ? { ...l, ...updates } : l)
        );
    };

    // Delete landmark
    const deleteLandmark = (id) => {
        setLandmarks(prev => prev.filter(l => l.id !== id));
    };

    return (
        <LandmarksContext.Provider
            value={{
                landmarks,
                addLandmark,
                updateLandmark,
                deleteLandmark
            }}
        >
            {children}
        </LandmarksContext.Provider>
    );
};

export default LandmarksProvider;
